/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorByline from 'base/components/labrador/Byline';

export const DynamicLabradorByline: typeof LabradorByline = (props) => {
    return <ErrorBoundary><LabradorByline {...props} /></ErrorBoundary>;
}
export type DynamicLabradorBylineProps = PropsFromComponent<typeof LabradorByline>;
